var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("ee-label ee-label--" + _vm.size),
    style: (("width:" + (_vm.width ? (_vm.width + "px"): 'auto')))
  }, [_vm._l((_vm.dataSource), function(k) {
    return _c('a', {
      class: {
        'is-active': _vm.isActive(k)
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.handleClick(k)
        }
      }
    }, [_vm._v(_vm._s(_vm.text(k))), _c('i', {
      staticClass: "text-icon icon-ok"
    })])
  }), _vm._v(" "), (_vm.errorMsg) ? _c('span', {
    staticClass: "ee-label__error-msg"
  }, [_vm._v("太多了")]) : _vm._e()], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f72e2a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/packages/label/Label.vue
// module id = 561
// module chunks = 13